import getWordEnding from "../../services/helpers/get-word-ending";
import months from "../../services/helpers/months";
import { toLocalDate } from "./utils";

/**
 * data-time-text - элемент для вывода текста
 * data-date - дата создания по серверному времени
 * data-origin - дата загрузки страницы по серверному времени
 */

/**
 * @class LiveItem
 * @classdesc Любой элемент с обновляющимся временем
 * 
 * @property {string} timeSelector селектор элемента, в который нужно выводить актуальное время с момента создания
 * 
 * @property {HTMLElement} time HTML-элемент, в который нужно выводить актуальное время
 * @property {Date} created дата создания по местному времени
 */
class LiveItem {
  /**
   * Периоды обновления строки времени
   */
  static get updatePeriods() {
    return {
      'm': 1000 * 60,
      'h': 1000 * 60 * 60,
    };
  }

  get timeSelector() {
    return "[data-time-text]";
  }

  /**
   * @constructor
   * @param {HTMLElement} el HTML-элемент
   */
  constructor(el) {
  
    this.el = el;
    this.el.liveItem = this;

    this.time = this.el.querySelector(this.timeSelector);
    if (!this.time) return;

    // дата создания (в формате местного времени)
    this.created = toLocalDate(this.el.dataset.date, this.el.dataset.origin);
    if (!this.created) return false;

    this.updateTimer = null;
    this.updatePeriod = LiveItem.updatePeriods.m;

    this.startUpdate();
  }

  update() {
    let time = this._getTimeString();
    this.time.textContent = time;
    return true;
  }

  _getTimeString() {
    let diff = new Date() - this.created;

    console.log('diff', diff)
    
    let seconds = diff / 1000;
    if (seconds < 60) {
      return "Только что";
    } 

    let minutes = seconds / 60;
    if (minutes < 60) {
      minutes = Math.floor(minutes);
      return minutes + " " + getWordEnding(minutes, getWordEnding.MINUTES.dat) + " назад";
    }

    this.updatePeriod = LiveItem.updatePeriods.h;

    let hours = minutes / 60;
    if (hours < 24) {
      hours = Math.floor(hours);
      return hours + " " + getWordEnding(hours, getWordEnding.HOURS.dat) + " назад";
    }

    this.updatePeriod = null;

    let date = this.created.getDate() + " " + months.gen[this.created.getMonth()];

    if (new Date().getFullYear() > this.created.getFullYear()) {
      date += " " + this.created.getFullYear();
    }

    return date;
  }

  startUpdate() {
    let update = () => {
      if (this.update() && this.updatePeriod) {
        this.updateTimer = setTimeout(() => update(), this.updatePeriod);
      }
    }

    update(); 
  }

  stopUpdate() {
    clearTimeout(this.updateTimer);
  }
};

export default LiveItem;